<section class="fbt">
  <h2 class="fbt__title">Frecuentemente comprados juntos</h2>

  <!-- Row visual: miniaturas con "+" entre ellas (desktop) -->
  <div class="fbt__preview" aria-hidden="true">
    @for (item of previewItems(); track item.id; let last = $last) {
      <div class="fbt__preview-thumb">
        <img
          [src]="item.imageUrl"
          [alt]="item.name"
          loading="lazy"
          class="fbt__preview-image"
        />
      </div>
      @if (!last) {
        <span class="fbt__preview-plus">+</span>
      }
    }
  </div>

  <!-- Lista con checkboxes -->
  <ul class="fbt__list">
    <li class="fbt__row">
      <div class="fbt__row-check">
        <app-checkbox
          id="fbt-current"
          [checked]="true"
          [disabled]="true"
        />
      </div>
      <div class="fbt__row-thumb">
        <img
          [src]="currentProduct().imageUrl"
          [alt]="currentProduct().name"
          loading="lazy"
          class="fbt__row-image"
        />
      </div>
      <div class="fbt__row-info">
        <span class="fbt__row-name">{{ currentProduct().name }}</span>
      </div>
      <span class="fbt__row-price">{{ formatItemPrice(currentProduct()) }}</span>
    </li>

    @for (suggestion of suggestions(); track suggestion.id) {
      <li class="fbt__row">
        <div class="fbt__row-check">
          <app-checkbox
            [id]="'fbt-' + suggestion.id"
            [checked]="isSelected(suggestion)"
            (checkedChange)="toggleSuggestion(suggestion, $event)"
          />
        </div>
        <div class="fbt__row-thumb">
          <img
            [src]="suggestion.imageUrl"
            [alt]="suggestion.name"
            loading="lazy"
            class="fbt__row-image"
          />
        </div>
        <div class="fbt__row-info">
          <span class="fbt__row-name">{{ suggestion.name }}</span>
        </div>
        <span class="fbt__row-price">{{ formatItemPrice(suggestion) }}</span>
      </li>
    }
  </ul>

  <!-- Total + CTA -->
  <div class="fbt__footer">
    <div class="fbt__total">
      <span class="fbt__total-label">
        Total ({{ totalCount() }} {{ totalCount() === 1 ? 'producto' : 'productos' }}):
      </span>
      <span class="fbt__total-value">{{ formattedTotal() }}</span>
    </div>
    <app-button
      variant="primary"
      size="lg"
      [disabled]="isAdding()"
      [loading]="isAdding()"
      (click)="onAddClick()"
    >
      Agregar seleccionados al carrito
    </app-button>
  </div>
</section>
